import {AddressSuggestion} from "../@types/address";

interface StoredAddress {
  address: AddressSuggestion;
  timestamp: number;
}

export const persistAddress = (address: AddressSuggestion): void => {
  const storedAddress: StoredAddress = {
    address,
    timestamp: Date.now()
  };
  localStorage.setItem('selectedAddress', JSON.stringify(storedAddress));
};

export const readAddress = (): AddressSuggestion | null => {
  const storedData = localStorage.getItem('selectedAddress');
  
  if (!storedData) {
    return null;
  }

  try {
    const storedAddress: StoredAddress = JSON.parse(storedData);
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
    
    // Check if the address is expired (older than 7 days)
    if (Date.now() - storedAddress.timestamp > sevenDaysInMs) {
      deleteAddress(); // Clean up expired address
      return null;
    }
    
    return storedAddress.address;
  } catch (error) {
    // If parsing fails, clean up and return null
    deleteAddress();
    return null;
  }
};

export const deleteAddress = (): void => localStorage.removeItem('selectedAddress');
